import { ROUTE } from '../constants/routes'; // Import the ROUTE constants

// Set value to control MultiOperation Selection based on feature flags
const getMultiOperationSelectorConfig = (featureFlags: Record<string, boolean> | null) => {
  if (!featureFlags) {
    return {
      [ROUTE.Dmb]: false,
      [ROUTE.FieldSelection]: true,
      [ROUTE.Dashboard]: false,
      [ROUTE.DataInbox]: false,
      [ROUTE.Reports]: true,
      [ROUTE.SeasonReports]: true,
      [ROUTE.VariableRate]: false,
      [ROUTE.Partners]: false,
      [ROUTE.AskFieldView]: false,
      [ROUTE.CropPlanning]: false,
      [ROUTE.Programs]: false,
      [ROUTE.ScriptCreator]: false,
      [ROUTE.InSeason]: true,
    };
  }

  return {
    [ROUTE.Dmb]: featureFlags['web.multi-operation-selection.dmb'] ?? false,
    [ROUTE.FieldSelection]: true,
    [ROUTE.Dashboard]: false,
    [ROUTE.DataInbox]: false,
    [ROUTE.Reports]: true,
    [ROUTE.SeasonReports]: true,
    [ROUTE.VariableRate]: false,
    [ROUTE.Partners]: false,
    [ROUTE.AskFieldView]: false,
    [ROUTE.CropPlanning]: false,
    [ROUTE.Programs]: false,
    [ROUTE.ScriptCreator]: false,
    [ROUTE.InSeason]: true,
  };
};

/**
 * Used to determine if app should get multiOperation Selector
 * @param {string} route
 * @param {Record<string, boolean> | null} featureFlags
 * @return {Boolean}
 */
export function shouldShowMultiOperationSelector(route: string, featureFlags: Record<string, boolean> | null): boolean {
  const config = getMultiOperationSelectorConfig(featureFlags);
  const baseRoute = `/${route.split('/')[1]}`;

  if (!route || !config[baseRoute]) {
    return false;
  }

  return config[baseRoute];
}